import fetchServer from "../fetchServer";

export default async function getAccounts(param, cancelToken, agency) {
  let result = { return: 0, msg: "Something went wrong updating profile!" };

  // const route = agency
  //   ? "/main/v1/account/getAllAgents"
  //   : "/main/v1/account/getAll";
  const route = "/main/v1/account/getAllAgents";
  // console.log({ route });
  await fetchServer({
    method: "GET",
    url: `${route}${param ? "?" + param : ""}&populate=detail`,
    // url: `${route}${param ? "?" + param : ""}&populate[]=detail.accountManager`,
    cancelToken,
  })
    .then((res) => {
      if (res?.data && !res?.data?.error) {
        result = { return: 1, msg: "Successfull", data: res.data?.data };
      } else result["msg"] = res?.data?.error || result["msg"];
    })
    .catch((err) => {
      console.log("Network Error!");
    });

  return result;
}
